import { apiClient } from "../config";

async function getFormDetails(id: string) {
  const res = await apiClient.get(`/admin/dynamic-forms/${id}`);
  return res.data;
}

export default getFormDetails;
